import { gql } from '@apollo/client';

export const ADD_CHANNEL = gql`
  mutation AddChannel($input: AddChannelInput!) {
    addChannel(input: $input) {
      channel {
        chId
        chName
        chHandle
        chDescription
        chAvatarUrl
        chBannerUrl
        chCreatedAt
        chUpdatedAt
      }
      message
    }
  }
`;

export type AddChannelInput = {
  chAvatarUrl: string;
  chBannerUrl: string;
  chDescription: string;
  chHandle: string;
  chName: string;
};

export type AddChannelData = {
  addChannel: {
    channel: {
      chId: string;
      chName: string;
      chHandle: string;
      chDescription: string;
      chAvatarUrl: string;
      chBannerUrl: string;
      chCreatedAt: string;
      chUpdatedAt: string;
    };
    message: string;
  };
};

export type AddChannelVariables = {
  input: AddChannelInput;
};

export const EDIT_CHANNEL = gql`
  mutation EditChannel($input: EditChannelInput!) {
    editChannel(input: $input)
  }
`;

export type EditChannelInput = {
  chId: string;
  chName?: string;
  chDescription?: string;
  chAvatarUrl?: string;
  chBannerUrl?: string;
  chHandle?:string;
};

export type EditChannelData = {
  editChannel: boolean | string | null;
};

export type EditChannelVariables = {
  input: EditChannelInput;
};

export const REMOVE_CHANNEL = gql`
  mutation RemoveChannel($chId: String!) {
    removeChannel(chId: $chId)
  }
`;

export type RemoveChannelData = {
  removeChannel: boolean | string | null;
};

export type RemoveChannelVariables = {
  chId: string;
};

export const FOLLOW_CHANNEL = gql`
  mutation FollowChannel($chId: String!) {
    followChannel(chId: $chId) {
      chId
      isFollowing
      message
    }
  }
`;

export type FollowChannelResult = {
  chId: string;
  isFollowing: boolean;
  message: string;
};

export type FollowChannelData = {
  followChannel: FollowChannelResult;
};

export type FollowChannelVariables = {
  chId: string;
};

export const UNFOLLOW_CHANNEL = gql`
  mutation UnfollowChannel($chId: String!) {
    unfollowChannel(chId: $chId) {
      message
      chId
      isFollowing
    }
  }
`;

export type UnfollowChannelData = {
  unfollowChannel: FollowChannelResult;
};

export type UnfollowChannelVariables = {
  chId: string;
};
